import { Guid } from "@iconics/core";
import '@serendie/ui/styles.css';
import { FadxPlatformApiClientV2, IFadxPlatformApiClientV2 } from "./Providers.FadxPlatformApiClientV2/FadxPlatformApiClientV2";
import { EmServiceWebEntryApiClientV1, IEmServiceWebEntryApiClientV1 } from "./Providers.EmServiceWebEntryApiClientV1/EmServiceWebEntryApiClientV1";
import { DeleteButton } from "./Buttons/DeleteButton/DeleteButton";
import { LanguageDialog } from "./Dialogs/LanguageDialog/LanguageDialog";
import { FileDropZone } from "./Inputs/FileDropZone/FileDropZone";
import { MediaSelector } from "./Inputs/MediaSelector/MediaSelector";
import { MultilingualTextField } from "./Inputs/MultilingualTextField/MultilingualTextField";
import { UserPicker } from "./Inputs/UserPicker/UserPicker";
import { PasswordField } from "./Inputs/PasswordField/PasswordField";
import { Select } from "./Inputs/Select/Select";
import { TextArea } from "./Inputs/TextArea/TextArea";
import { TextField } from "./Inputs/TextField/TextField";
import { AlertDialog } from "./Dialogs/AlertDialog/AlertDialog";
import { ConfirmDialog } from "./Dialogs/ConfirmDialog/ConfirmDialog";

export class Components
{
    public fadxPlatformApiClientV2!: IFadxPlatformApiClientV2;
    public webEntryApiClientV1!: IEmServiceWebEntryApiClientV1;
    public isDevMode = false;

    public initialise(settings: {
        platformApiV2Url: string,
        webEntryApiV1Url: string,
        isDevMode?: boolean,
    }): Components
    {
        this.fadxPlatformApiClientV2 = new FadxPlatformApiClientV2({ baseUrl: settings.platformApiV2Url });
        this.webEntryApiClientV1 = new EmServiceWebEntryApiClientV1({ baseUrl: settings.webEntryApiV1Url });
        this.isDevMode = settings.isDevMode ?? false;
        window.addEventListener('resize', this.resizeListener);
        return this;
    }

    public configureDeleteButton(settings: {
        buttonLabel?: string;
        dialogTitle?: string;
        dialogMessage?: string;
        dialogConfirmDeleteLabel?: string;
    }): Components
    {
        DeleteButton.buttonLabel = settings.buttonLabel ?? DeleteButton.buttonLabel;
        DeleteButton.dialogTitle = settings.dialogTitle ?? DeleteButton.dialogTitle;
        DeleteButton.dialogMessage = settings.dialogMessage ?? DeleteButton.dialogMessage;
        DeleteButton.dialogConfirmDeleteLabel = settings.dialogConfirmDeleteLabel ?? DeleteButton.dialogConfirmDeleteLabel;
        return this;
    }

    public configureAlertDialog(settings: {
        okButtonLabel?: string;
    }): Components
    {
        AlertDialog.okButtonLabel = settings.okButtonLabel ?? LanguageDialog.okButtonLabel;
        return this;
    }

    public configureConfirmDialog(settings: {
        okButtonLabel?: string;
        cancelButtonLabel?: string;
    }): Components
    {
        ConfirmDialog.okButtonLabel = settings.okButtonLabel ?? LanguageDialog.okButtonLabel;
        ConfirmDialog.cancelButtonLabel = settings.cancelButtonLabel ?? LanguageDialog.cancelButtonLabel;
        return this;
    }

    public configureLanguageDialog(settings: {
        title?: string;
        subTitle?: string;
        languageInputLabel?: string;
        okButtonLabel?: string;
        cancelButtonLabel?: string;
    }): Components
    {
        LanguageDialog.title = settings.title ?? LanguageDialog.title;
        LanguageDialog.subTitle = settings.subTitle ?? LanguageDialog.subTitle;
        LanguageDialog.languageInputLabel = settings.languageInputLabel ?? LanguageDialog.languageInputLabel;
        LanguageDialog.okButtonLabel = settings.okButtonLabel ?? LanguageDialog.okButtonLabel;
        LanguageDialog.cancelButtonLabel = settings.cancelButtonLabel ?? LanguageDialog.cancelButtonLabel;
        return this;
    }

    public configureFileDropZone(settings: {
        prompt?: string;
        selectButtonLabel?: string;
        resetButtonLabel?: string;
    }): Components
    {
        FileDropZone.prompt = settings.prompt ?? FileDropZone.prompt;
        FileDropZone.selectButtonLabel = settings.selectButtonLabel ?? FileDropZone.selectButtonLabel;
        FileDropZone.resetButtonLabel = settings.resetButtonLabel ?? FileDropZone.resetButtonLabel;
        return this;
    }

    public configureMediaSelector(settings: {
        selectButtonLabel?: string;
        dialogTitle?: string;
        duplicateImageError?: string;
        selectedImageLabel?: string;
        okButtonLabel?: string;
        cancelButtonLabel?: string;
    }): Components
    {
        MediaSelector.selectButtonLabel = settings.selectButtonLabel ?? MediaSelector.selectButtonLabel;
        MediaSelector.dialogTitle = settings.dialogTitle ?? MediaSelector.dialogTitle;
        MediaSelector.duplicateImageError = settings.duplicateImageError ?? MediaSelector.duplicateImageError;
        MediaSelector.selectedImageLabel = settings.selectedImageLabel ?? MediaSelector.selectedImageLabel;
        MediaSelector.okButtonLabel = settings.okButtonLabel ?? MediaSelector.okButtonLabel;
        MediaSelector.cancelButtonLabel = settings.cancelButtonLabel ?? MediaSelector.cancelButtonLabel;
        return this;
    }

    public configureMultilingualTextField(settings: {

        unknownLanguageLabel?: string;
        dialogTitle?: string;
        dialogSubTitle?: string;
        okButtonLabel?: string;
        cancelButtonLabel?: string;
    }): Components
    {
        MultilingualTextField.unknownLanguageLabel = settings.unknownLanguageLabel ?? MultilingualTextField.unknownLanguageLabel;
        MultilingualTextField.dialogTitle = settings.dialogTitle ?? MultilingualTextField.dialogTitle;
        MultilingualTextField.dialogSubTitle = settings.dialogSubTitle ?? MultilingualTextField.dialogSubTitle;
        MultilingualTextField.okButtonLabel = settings.okButtonLabel ?? MultilingualTextField.okButtonLabel;
        MultilingualTextField.cancelButtonLabel = settings.cancelButtonLabel ?? MultilingualTextField.cancelButtonLabel;
        return this;
    }

    public configurePasswordField(settings: {
        requiredLabel?: string;
    }): Components
    {
        PasswordField.requiredLabel = settings.requiredLabel ?? PasswordField.requiredLabel;
        return this;
    }

    public configureSelect(settings: {
        requiredLabel?: string;
    }): Components
    {
        Select.requiredLabel = settings.requiredLabel ?? Select.requiredLabel;
        return this;
    }

    public configureTextArea(settings: {
        requiredLabel?: string;
    }): Components
    {
        TextArea.requiredLabel = settings.requiredLabel ?? TextArea.requiredLabel;
        return this;
    }

    public configureTextField(settings: {
        requiredLabel?: string;
    }): Components
    {
        TextField.requiredLabel = settings.requiredLabel ?? TextField.requiredLabel;
        return this;
    }

    public configureUserPicker(settings: {

        label?: string;
        noUserSelectedLabel?: string;
    }): Components
    {
        UserPicker.label = settings.label ?? UserPicker.label;
        UserPicker.noUserSelectedLabel = settings.noUserSelectedLabel ?? UserPicker.noUserSelectedLabel;
        return this;
    }

    private readonly resizeListener = () => this.handleWindowResize();
    private getScreenSize(): ScreenSize { return (window.innerWidth < 1052 ? 'compact' : 'expanded'); }
    private screenSize: ScreenSize = 'expanded';

    private handleWindowResize(): void
    {
        if (this.getScreenSize() == this.screenSize)
        {
            return;
        }
        this.screenSize = this.getScreenSize();
        this.resizeHandlers.forEach(i => i(this.screenSize));
    }

    private resizeHandlers = new Map<string, (screenSize: ScreenSize) => void>();

    public addResizeHandler(handler: (screenSize: ScreenSize) => void, onAdded: (handlerId: string) => void): Components
    {
        const id = Guid.new().toString();
        this.resizeHandlers.set(id, handler);
        onAdded(id);
        return this;
    }

    public removeResizeHandler(id: string): Components
    {
        this.resizeHandlers.delete(id);
        return this;
    }

    private lastScrollTop = 0;
    public scrollDirection: '' | 'up' | 'down' = '';

    public handleLayoutContainerScroll(e: React.UIEvent<HTMLDivElement, UIEvent>): void
    {
        const target = e.target as HTMLElement;
        const scrollTop = target.scrollTop;
        this.scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up';
        this.lastScrollTop = scrollTop;
        this.layoutContainerScrollHandlers.forEach(i => i(e));
    }

    private layoutContainerScrollHandlers = new Map<string, (e: React.UIEvent<HTMLDivElement, UIEvent>) => void>();

    public addLayoutContainerScrollHandler(handler: (e: React.UIEvent<HTMLDivElement, UIEvent>) => void, onAdded: (handlerId: string) => void): Components
    {
        const id = Guid.new().toString();
        this.layoutContainerScrollHandlers.set(id, handler);
        onAdded(id);
        return this;
    }

    public removeLayoutContainerScrollHandler(id: string): Components
    {
        this.layoutContainerScrollHandlers.delete(id);
        return this;
    }

    public dispose(): void
    {
        window.removeEventListener('resize', this.resizeListener);
    }
}

export const components = new Components();
export type ScreenSize = 'compact' | 'expanded';
